"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sesto": {
    "d9f8beb8": [{
      "hkey": "0218a8ca",
      "slug": "sesto",
      "name": "Sesto",
      "primary": true,
      "skipSearch": false
    }],
    "ferrara": [{
      "hkey": "0218a8ca",
      "slug": "sesto",
      "name": "Sesto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9d8adca9": [{
      "hkey": "0218a8ca",
      "slug": "sesto",
      "name": "Sesto",
      "primary": true,
      "skipSearch": false
    }],
    "monte-di-mezzo": [{
      "hkey": "0218a8ca",
      "slug": "sesto",
      "name": "Sesto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1929240e": [{
      "hkey": "0218a8ca",
      "slug": "sesto",
      "name": "Sesto",
      "primary": true,
      "skipSearch": false
    }],
    "quiniga": [{
      "hkey": "0218a8ca",
      "slug": "sesto",
      "name": "Sesto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9bfe1a7b": [{
      "hkey": "0218a8ca",
      "slug": "sesto",
      "name": "Sesto",
      "primary": true,
      "skipSearch": false
    }],
    "san-vito": [{
      "hkey": "0218a8ca",
      "slug": "sesto",
      "name": "Sesto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;